import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-view-mode-kanban",
  "use": "foquz-icon-view-mode-kanban-usage",
  "viewBox": "0 0 22 18",
  "content": "<symbol viewBox=\"0 0 22 18\" fill=\"none\" id=\"foquz-icon-view-mode-kanban\"><path d=\"M1 1h4v16H1V1zm8 0h4v16H9V1zm8 0h4v16h-4V1z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol